<template>
  <div v-resize="setContentHeight">
    <v-card
      :height="visitBranchMenus ? '140px' : '104px'"
      style="border-radius: 0px"
      color="primary"
      class="pr-1"
    >
      <!-- Toolbar -->
      <v-toolbar
        id="newBookingToolbar"
        dark
        elevation="0"
        color="primary"
        style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px"
      >
        <img
          img aria-label="NLB Logo"
          :src="`${this.iconPath}nlb-logo-white.png`"
          style="height: 48px; widthx: 24px"
          class="mr-3"
        />

        <v-toolbar-title>New Booking</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn aria-label="Show help" @click="$router.push({ name: 'Help' }, () => {})" icon>
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>

        <v-btn icon>
          <LoginIcon />
        </v-btn>
      </v-toolbar>

      <!-- Seat & visit tab buttons -->
      <div v-if="visitBranchMenus" class="pl-2 mt-2">
        <v-btn
          color="white"
          height="34"
          class="text-capitalize"
          style="margin-right: 6px; border-radius: 8px"
          :class="
            !showSeatBookingSearchForm
              ? 'primary--text font-weight-black'
              : 'white--text font-weight-regular'
          "
          :outlined="showSeatBookingSearchForm"
          @click="showSeatBookingSearchForm = false"
          >Visit</v-btn
        >
        <v-btn
          color="white"
          height="34"
          class="text-capitalize"
          style="border-radius: 8px"
          :class="
            showSeatBookingSearchForm
              ? 'primary--text font-weight-black'
              : 'white--text font-weight-regular'
          "
          :outlined="!showSeatBookingSearchForm"
          @click="seatBookingUnavailableForEmaiMobileLogin"
          >Seat</v-btn
        >
      </div>
    </v-card>

    <div
      ref="homeScrollable"
      class="scrollable"
      :style="
        visitBranchMenus
          ? 'margin-top: -36px !important'
          : 'margin-top: -45px !important'
      "
    >
      <div v-if="visitBranchMenus" v-show="!showSeatBookingSearchForm">
        <VisitBookingSearchForm ref="visitBookingSearchForm" />
      </div>

      <v-card
        v-if="
          (!visitBranchMenus || showSeatBookingSearchForm) &&
          settings &&
          inputPopupSelectBranch.selectedItem
        "
        class="mx-2 px-5 pt-4 pb-3 mb-2"
        style="border-radius: 8px"
      >
        <!-- Select library -->
        <div
          class="inputPopupSelectDiv"
          @click="inputPopupSelectBranch.show = true"
        >
          <span class="label">Library</span>
          <v-text-field
            aria-label="Select library"
            :value="inputPopupSelectBranch.selectedItem.name"
            readonly
          >
            <v-icon slot="prepend-inner">mdi-library</v-icon>
          </v-text-field>

          <InputPopupSelect
            title="Library"
            :list="seatBranchMenus"
            :select.sync="inputPopupSelectBranch"
          />
        </div>

        <!-- Select area -->
        <div
          class="inputPopupSelectDiv"
          @click="inputPopupSelectArea.show = true"
        >
          <span class="label">Area</span>
          <v-text-field
            aria-label="Select area"
            prepend-inner-icon="mdi-map-marker"
            :value="
              inputPopupSelectArea.selectedItem
                ? inputPopupSelectArea.selectedItem.name
                : 'All'
            "
            readonly
          >
            <v-icon
              v-if="inputPopupSelectArea.selectedItem"
              slot="append"
              @click.stop="clearArea"
              >mdi-close</v-icon
            >
          </v-text-field>

          <InputPopupSelect
            title="Area"
            :list="inputPopupSelectBranch.selectedItem.areas"
            :select.sync="inputPopupSelectArea"
          />
        </div>

        <!-- Select date -->
        <div
          class="inputPopupSelectDiv"
          @click="inputPopupSelectDate.show = true"
        >
          <span class="label">Date</span>
          <v-text-field
            aria-label="Select date"
            prepend-inner-icon="mdi-calendar-month"
            :value="formatDate(inputPopupSelectDate.selectedItem)"
            readonly
          ></v-text-field>

          <InputPopupSelectDate
            :select.sync="inputPopupSelectDate"
            :min="bookingStartDateString"
            :max="bookingEndDateString"
          />
        </div>

        <v-row no-gutters>
          <!-- Select time -->
          <v-col
            @click="inputPopupSelectTime.show = true"
            class="inputPopupSelectDiv"
          >
            <span class="label">Time</span>
            <v-text-field
              aria-label="Select time"
              prepend-inner-icon="mdi-clock-outline"
              :value="inputPopupSelectTime.selectedItem.name"
              readonly
            ></v-text-field>

            <InputPopupSelect
              title="Time"
              maxWidth="270px"
              :list="timeList"
              :select.sync="inputPopupSelectTime"
            />
          </v-col>

          <!-- Select duration -->
          <v-col
            @click="inputPopupSelectDuration.show = true"
            class="inputPopupSelectDiv"
          >
            <span class="label text-truncate">Duration (Hour : Min)</span>
            <v-text-field
              aria-label="Select duration"
              prepend-inner-icon="mdi-timer-sand"
              :value="inputPopupSelectDuration.selectedItem.name"
              readonly
            ></v-text-field>

            <InputPopupSelect
              title="Duration (Hour : Min)"
              maxWidth="270px"
              :list="durationList"
              :select.sync="inputPopupSelectDuration"
            />
          </v-col>
        </v-row>

        <!-- Buttons -->
        <div class="button-group" style="margin-top: 18px; margin-bottom: 18px">
          <v-row>
            <v-col>
              <v-btn
                @click="reset"
                dark
                color="primary"
                class="px-5"
                large
                block
              >
                <v-icon left dark>mdi-cached</v-icon>Reset
              </v-btn>
            </v-col>

            <v-col>
              <v-btn
                @click="
                  $router.push({
                    name: 'ScanQRCode',
                    params: { state: 'home' },
                  })
                "
                dark
                color="primary"
                class
                large
                block
              >
                <v-icon left dark>mdi-qrcode</v-icon>QR Code
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                dark
                color="deep-orange darken-4"
                large
                class
                block
                @click="search"
              >
                <v-icon left dark>mdi-magnify</v-icon>Check available slots
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import LoginIcon from "@/components/LoginIcon";
import InputPopupSelect from "@/components/InputPopupSelect";
import InputPopupSelectDate from "@/components/InputPopupSelectDate";
import VisitBookingSearchForm from "@/components/VisitBookingSearchForm";
import formatters from "@/helpers/formatters";
import calculator from "@/helpers/calculator";
import apiHelper from "@/helpers/apiHelper";
import businessLogic from "@/helpers/businessLogic";
import validators from "@/helpers/validators";

export default {
  name: "Home",
  components: {
    LoginIcon,
    InputPopupSelect,
    InputPopupSelectDate,
    VisitBookingSearchForm,
  },
  data: () => ({
    showSeatBookingSearchForm: false,
    inputPopupSelectBranch: {
      show: false,
      selectedItem: {
        //PublicBranchMenu
        name: null,
        code: null,
      },
    },
    inputPopupSelectArea: {
      show: false,
      selectedItem: null, //PublicAreaMenu (null = "All" areas)
    },
    inputPopupSelectDate: {
      show: false,
      selectedItem: null, //yyyy-MM-dd
    },
    inputPopupSelectTime: {
      show: false,
      selectedItem: {
        name: null,
        code: null, //HH-mm
      },
    },
    inputPopupSelectDuration: {
      show: false,
      selectedItem: {
        name: null,
        code: null, //Minutes
      },
    },
  }),
  computed: {
    ...mapState(["qrCode", "locationInfoFromQrCode"]),
    ...mapGetters([
      "mode",
      "seatBranchMenus",
      "visitBranchMenus",
      "isEmailMobileLogin",
    ]),
    selectedBranch() {
      return this.inputPopupSelectBranch.selectedItem;
    },
    selectedArea() {
      return this.inputPopupSelectArea.selectedItem;
    },
    selectedDate() {
      return this.inputPopupSelectDate.selectedItem;
    },
    selectedTime() {
      return this.inputPopupSelectTime.selectedItem;
    },
    selectedDuration() {
      return this.inputPopupSelectDuration.selectedItem;
    },
    isSameDate() {
      return this.time.nowMoment.isSame(moment(this.selectedDate), "day");
    },
    lastBookingTime() {
      //lastBookingTime = closingTime - minBookingMinutes
      const lastBookingTime = calculator
        .toTodaysTime(
          moment(this.areaDependentSettings.closingTime),
          this.time.todayMoment
        )
        .clone()
        .subtract(this.areaDependentSettings.minBookingMinutes, "minutes");

      return lastBookingTime;
    },
    bookingStartDateString() {
      //TODO: Better logic that considers holidays and no advance booking, etc.

      const bookingStartDate =
        this.time.nowMoment >= this.lastBookingTime
          ? this.time.nowMoment.clone().add(1, "days")
          : this.time.nowMoment;

      return bookingStartDate.format("YYYY-MM-DD");
    },
    bookingEndDateString() {
      return this.bookingEndTime.clone().add(-1, "days").format("YYYY-MM-DD");
    },
    bookingEndTime() {
      const bookingEndTime = calculator.bookingEndTime(
        this.settings.system.advanceBookingDays,
        this.settings.system.bookingReleaseTime,
        this.time
      );

      return bookingEndTime;
    },
    timeList() {
      const timeList = calculator.timeList(
        moment(this.areaDependentSettings.openingTime),
        this.lastBookingTime,
        this.areaDependentSettings.bookingTimeslotInMinutes,
        this.isSameDate,
        this.time.nowMoment,
        this.time.todayMoment
      );

      return timeList;
    },
    durationList() {
      let quotaLeftInMinutes = Infinity;
      const selectedTimeMoment = moment(this.selectedTime.code, "HH:mm");
      const closingTimeMoment = moment(this.areaDependentSettings.closingTime);

      let maxBookingMinutes = this.dwellMinutesOfTheDay
        ? Math.min(
            this.dwellMinutesOfTheDay,
            this.areaDependentSettings.maxBookingMinutes
          )
        : this.areaDependentSettings.maxBookingMinutes;

        // For "maxBookingMinutes", it has to be at least 1 hour
        // Or it must be the quotaLeft

        //maxBookingMinutes = Math.max(1 hour, quotaLeft);

        if (
          this.accountInfo &&
          this.accountInfo.dailyBookingQuotas &&
          this.accountInfo.dailyBookingQuotas.length
        ) {
            if (validators.isToday(
              this.inputPopupSelectDate.selectedItem,
              this.time.nowMoment
            )) {
              // If selected date is today, get quota from dailyBookingQuotas
              // Find the entry with the maximum remainingQuotaInMinutes within dailyBookingQuotas

              const remainingDailyBookingQuotas = this.accountInfo.dailyBookingQuotas;

              quotaLeftInMinutes = remainingDailyBookingQuotas.reduce((max, quota) => {
                  return quota.remainingQuotaInMinutes > max.remainingQuotaInMinutes ? quota : max;
              }, remainingDailyBookingQuotas[0].remainingQuotaInMinutes);
            } else {
              // If selected date is not today, get quota from advancedDailyBookingQuotas
              // Find the entry with the maximum remainingQuotaInMinutes within advancedBookingQuotas

              const remainingAdvancedBookingQuotas = this.accountInfo.advancedBookingQuotas;

              quotaLeftInMinutes = remainingAdvancedBookingQuotas.reduce((maxEntry, booking) => {
                  const maxQuotaEntry = booking.advancedDailyBookingQuotas.reduce((max, quota) => {
                      return quota.remainingQuotaInMinutes > max.remainingQuotaInMinutes ? quota : max;
                  }, booking.advancedDailyBookingQuotas[0]);

                  return maxQuotaEntry.remainingQuotaInMinutes > maxEntry.remainingQuotaInMinutes ? maxQuotaEntry : maxEntry;
              }, remainingAdvancedBookingQuotas[0].advancedDailyBookingQuotas[0].remainingQuotaInMinutes);
            }

            maxBookingMinutes = Math.max(this.settings.system.extensionMinutes, quotaLeftInMinutes); // To have a minimum bookable duration of 1 hour as still need to enable the 2 free overbookings
        }

      const durationList = calculator.durationList(
        this.areaDependentSettings.minBookingMinutes,
        maxBookingMinutes,
        this.areaDependentSettings.bookingTimeslotInMinutes,
        closingTimeMoment,
        selectedTimeMoment,
        this.time.todayMoment
      );

      return durationList;
    },
    dwellMinutesOfTheDay() {
      const selectedBranch = this.inputPopupSelectBranch.selectedItem;
      const branchDwellTime = selectedBranch.dwellTime;

      const dwellMinutesOfTheDay = businessLogic.getDwellTimeMinutes(
        this.settings.holidays,
        branchDwellTime,
        this.selectedDate
      );

      return dwellMinutesOfTheDay;
    },
    areaDependentSettings() {
      //This guy is added for Bloomberg terminal SR, some settings are dynamic now, depending on which area is selected
      const selectedArea = this.inputPopupSelectArea.selectedItem;

      if (selectedArea) {
        const areaDependentSettings = {
          openingTime: selectedArea.openingTime,
          closingTime: selectedArea.closingTime,
          bookingTimeslotInMinutes: selectedArea.bookingTimeslotInMinutes,
          minBookingMinutes: selectedArea.minBookingMinutes,
          maxBookingMinutes: selectedArea.maxBookingMinutes,
        };

        return areaDependentSettings;
      } else {
        const allAreasInSelectedBranch =
          this.inputPopupSelectBranch.selectedItem.areas;

        // const earliestOpeningTime = allAreasInSelectedBranch.reduce(
        //   (p, c) => (p < c.openingTime ? p.openingTime : c.openingTime),
        //   allAreasInSelectedBranch[0].openingTime
        // );

        const earliestOpeningTime = allAreasInSelectedBranch.reduce(
          (p, c) => new Date(p.openingTime) < new Date(c.openingTime) ? p : c,
          allAreasInSelectedBranch[0]
        ).openingTime;

        // const latestClosingTime = allAreasInSelectedBranch.reduce(
        //   (p, c) => (p > c.closingTime ? p.closingTime : c.closingTime),
        //   allAreasInSelectedBranch[0].closingTime
        // );

        const latestClosingTime = allAreasInSelectedBranch.reduce(
          (p, c) => new Date(p.closingTime) > new Date(c.closingTime) ? p : c,
          allAreasInSelectedBranch[0]
        ).closingTime;

        const smallestBookingTimeslotInMinutes =
          allAreasInSelectedBranch.reduce(
            (p, c) =>
              p < c.bookingTimeslotInMinutes ? p : c.bookingTimeslotInMinutes,
            allAreasInSelectedBranch[0].bookingTimeslotInMinutes
          );

        const smallestMinBookingMinutes = allAreasInSelectedBranch.reduce(
          (p, c) => (p < c.minBookingMinutes ? p : c.minBookingMinutes),
          allAreasInSelectedBranch[0].minBookingMinutes
        );

        const largestMaxBookingMinutes = allAreasInSelectedBranch.reduce(
          (p, c) => (p > c.maxBookingMinutes ? p : c.maxBookingMinutes),
          allAreasInSelectedBranch[0].maxBookingMinutes
        );

        const areaDependentSettings = {
          openingTime: earliestOpeningTime,
          closingTime: latestClosingTime,
          bookingTimeslotInMinutes: smallestBookingTimeslotInMinutes,
          minBookingMinutes: smallestMinBookingMinutes,
          maxBookingMinutes: largestMaxBookingMinutes,
        };

        return areaDependentSettings;
      }
    },
  },
  methods: {
    ...mapMutations([
      "updateQrCode",
      "updateLocationInfoFromQrCode",
      "updateSearchResults",
      "updateSelectedArea",
    ]),
    reset() {
      //Reset branch
      if (this.onsiteMode) {
        const branch = this.seatBranchMenus.find(
          (x) => x.id === this.mode.branchId
        );

        if (branch) {
          this.inputPopupSelectBranch.selectedItem = branch;
        }

        //Reset branch & area
        // if (this.mode.mode === constants.mode.OnsiteModeQrCode) {
        //   this.updateBranchAndAreaInputs(this.locationInfoFromQrCode);
        // } else {
        //   const branch = this.seatBranchMenus.find(
        //     (x) => x.id === this.mode.branchId
        //   );

        //   if (branch) {
        //     this.inputPopupSelectBranch.selectedItem = branch;
        //   }
        // }
      }

      //Reset area
      this.inputPopupSelectArea.selectedItem = null;

      //Reset date, time, duration
      if (this.bookingStartDateString) {
        this.inputPopupSelectDate.selectedItem = this.bookingStartDateString;

        if (this.timeList) {
          this.inputPopupSelectTime.selectedItem = this.timeList[0];

          if (this.durationList) {
            this.inputPopupSelectDuration.selectedItem = this.durationList[0];
          }
        }
      }
    },
    seatBookingUnavailableForEmaiMobileLogin() {
      if (this.isEmailMobileLogin) {
        this.updateSystemAlert({
          show: true,
          success: false,
          message: window.$msg.notEligbleToBookSeat,
        });
      } else {
        this.showSeatBookingSearchForm = true;
      }
    },
    async search() {
      const branchId = this.selectedBranch.id;
      const areaId = this.selectedArea ? this.selectedArea.id : null;
      const starTime = this.selectedDate + "T" + this.selectedTime.code;
      const durationInMinutes = this.selectedDuration.code;
      const seatCode = this.mode.seatCode ? this.mode.seatCode : null;

      const searchResponse = await apiHelper.search(
        branchId,
        areaId,
        starTime,
        durationInMinutes,
        seatCode
      );

      //commonResponseHandler is not used in this case, because this handler is a bit different
      //IM8 logout takes the highest priority
      if (searchResponse === window.$msg.reloginRequired) {
        businessLogic.im8Logout();

        return;
      }

      if (
        searchResponse &&
        searchResponse.data &&
        searchResponse.data.areas &&
        searchResponse.data.areas.length
      ) {
        this.updateSearchResults(searchResponse.data);

        // this.updateLoading({ show: false });
        if (
          searchResponse.data.found &&
          searchResponse.data.areas.length === 1
        ) {
          this.updateSelectedArea(searchResponse.data.areas[0]);
          this.$router.push({
            name: "BookingDetails",
            params: {
              selectedSeatName: searchResponse.data.selectedSeatName,
            },
          });
        } else {
          this.$router.push({
            name: "SearchResults",
          });
        }
      } else {
        this.updateResult({
          show: true,
          success: false,
          title: window.$msg.noResultsFoundTitle,
          message: window.$msg.noResultsFoundMsg,
        });
        // this.updateLoading({ show: false, notRevertStatusBarColor: true });
      }
    },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    clearArea(event) {
      this.inputPopupSelectArea.selectedItem = null;
    },
    updateBranchAndAreaInputs(locationInfo) {
      const branch = this.seatBranchMenus.find(
        (x) => x.id === locationInfo.branchId
      );

      if (branch) {
        this.inputPopupSelectBranch.selectedItem = branch;

        if (locationInfo.placeCode) {
          const area = branch.areas.find(
            (x) =>
              x.code.toLowerCase() === locationInfo.placeCode.toLowerCase() &&
              x.floor.toString() === locationInfo.floor
          );

          //For testing only - Start
          // const shortPlaceCode = locationInfo.placeCode.substr(
          //   locationInfo.placeCode.lastIndexOf(".") + 1
          // );

          // const area = branch.areas.find((x) => {
          //   if (x.code.includes(".")) {
          //     let shortCode = x.code.substr(x.code.lastIndexOf(".") + 1);
          //     return shortPlaceCode === shortCode;
          //   } else {
          //     return shortPlaceCode === x.code;
          //   }
          // });
          //For testing only - End

          if (area) {
            this.inputPopupSelectArea.selectedItem = area;
          }
        }
      }
    },
    setContentHeight() {
      if (this.$refs.homeScrollable) {
        const heights = this.heights();

        const contentHeight = this.visitBranchMenus
          ? heights.screen - heights.toolbarWithButtons - heights.bottombar - heights.noticeBarHeight
          : heights.screen - heights.toolbar - heights.bottombar - heights.noticeBarHeight;

        this.$refs.homeScrollable.style.height = contentHeight + "px";
      }
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          if (this.onsiteMode) {
            const branch = this.seatBranchMenus.find(
              (x) => x.id === this.mode.branchId
            );

            if (branch) {
              this.inputPopupSelectBranch.selectedItem = branch;
              return;
            }
          }

          this.inputPopupSelectBranch.selectedItem = this.seatBranchMenus[0];

          // setTimeout(() => {
          //   this.reset();
          // }, 10);
        }
      },
    },
    inputPopupSelectBranch(newValue, oldValue) {
      if (newValue.selectedItem !== oldValue.selectedItem) {
        this.inputPopupSelectArea.selectedItem = null;
      }
    },
    bookingStartDateString: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          //Mainly used for the initial update, and
          //to auto-update calandar to tomorrow when there is no timeslot left for the selected area today
          if (
            !this.inputPopupSelectDate.selectedItem ||
            validators.isToday(
              this.inputPopupSelectDate.selectedItem,
              this.time.nowMoment
            )
          ) {
            this.inputPopupSelectDate.selectedItem =
              this.bookingStartDateString;
          }
        }
      },
    },
    timeList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length) {
          const timeNameList = newValue.map((x) => x.name);

          if (!timeNameList.includes(this.selectedTime.name)) {
            this.inputPopupSelectTime.selectedItem = newValue[0];
          }
        }
      },
    },
    durationList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length) {
          const durationList = newValue.map((x) => x.name);

          if (!durationList.includes(this.selectedDuration.name)) {
            this.inputPopupSelectDuration.selectedItem = newValue[0];
          }
        }
      },
    },
    qrCode(newValue, oldValue) {
      if (newValue && newValue.value && newValue.state === "home") {
        //Update locationInfoFromQrCode
        const locationInfo = businessLogic.getLocationInfoFromQrCode(
          newValue.value,
          this.seatBranchMenus
        );

        if (locationInfo) {
          this.updateBranchAndAreaInputs(locationInfo);
          this.updateLocationInfoFromQrCode(locationInfo);
          //Seat button is selected when area or seat QR code URL is detected
          this.showSeatBookingSearchForm = true;
        } else {
          this.updateSystemDialog({
            title: window.$msg.invalidQrCodeTitle,
            message: window.$msg.invalidQrCodeMsg,
          });
        }
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.name === "Home" && (!from || from.name === "Home")) {
          if (
            this.$route.fullPath &&
            this.$route.query &&
            this.$route.query.loc
          ) {
            //Update locationInfo from URL
            const locationInfo = businessLogic.getLocationInfoFromQrCode(
              this.$route.fullPath,
              this.seatBranchMenus
            );

            if (locationInfo) {
              this.updateLocationInfoFromQrCode(locationInfo);
              //Seat button is selected when area or seat QR code URL is detected
              this.showSeatBookingSearchForm = true;
              this.updateBranchAndAreaInputs(locationInfo);

              //Query string changed detected, processed, removed
              this.$router.replace({ query: null }).catch((ex) => {});
            }
          }
        }
      },
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.showSeatBookingSearchForm && vm.isEmailMobileLogin) {
        vm.showSeatBookingSearchForm = false;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    //Cause the back button to close any popups instead of navigate to another page
    if (this.$refs.visitBookingSearchForm) {
      const stopNavigation = this.$refs.visitBookingSearchForm.beforeRouteLeave(
        to,
        from,
        next
      );

      if (stopNavigation) {
        next(false);
        return;
      }
    }

    const inputs = [
      this.inputPopupSelectBranch,
      this.inputPopupSelectArea,
      this.inputPopupSelectDate,
      this.inputPopupSelectTime,
      this.inputPopupSelectDuration,
    ];

    for (const i of inputs) {
      if (i != null && i.show) {
        i.show = false;

        next(false);
        return;
      }
    }

    next();
  },
};
</script>

<style scoped>
.label {
  font-weight: bold;
  font-size: 14px;
}

.button-group {
  margin: 6px;
}

.button-group .col {
  margin: 5px;
  padding: 0px;
}

.v-list-item__content {
  padding: 0;
}

.v-btn--outlined {
  /* border-width: 1.9px; */
}

.inputPopupSelectDiv {
  margin-bottom: 24px;
}

</style>

<style>
#newBookingToolbar .v-toolbar__content,
.v-toolbar__extension {
  padding-left: 10px !important;
}
</style>
